import { Link, useLocation, Outlet } from 'react-router-dom'
import { UserButton, useUser } from '@clerk/clerk-react'
import { useTheme } from '../hooks/useTheme'

export default function AppShell() {
  const { pathname } = useLocation()
  const { user } = useUser()
  const { theme, toggle } = useTheme()

  const navItems = [
    { to: '/dashboard', label: 'Dashboard' },
    { to: '/invoices/new', label: 'New Invoice' },
    { to: '/settings', label: 'Settings' },
  ]

  return (
    <div className="min-h-screen bg-ica-bg text-ica-text">
      <header className="sticky top-0 z-50 border-b border-ica-border bg-ica-bg/80 backdrop-blur-md">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
          <Link to={user ? '/dashboard' : '/'} className="text-sm font-semibold tracking-tight">
            Invoice Chase
          </Link>

          <nav className="flex items-center gap-1">
            {user && navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-lg px-3 py-1.5 text-sm font-medium transition-colors ${
                  pathname === item.to
                    ? 'bg-ica-elevated text-ica-text'
                    : 'text-ica-text-secondary hover:text-ica-text'
                }`}
              >
                {item.label}
              </Link>
            ))}

            <button
              onClick={toggle}
              className="ml-2 rounded-lg p-1.5 text-ica-text-muted transition-colors hover:bg-ica-elevated hover:text-ica-text"
              aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
            >
              {theme === 'dark' ? (
                <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              ) : (
                <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                </svg>
              )}
            </button>

            {user && <UserButton />}
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  )
}
